import { axiosClient } from "../axios";

const businessUrl = "/api/docs/business-plans";
const reportUrl = "/api/ai/reports";

export function get(businessPlanId) {
  return axiosClient.get(`${businessUrl}/${businessPlanId}/ai-reports`);
}

export function generate(businessPlanId) {
  return axiosClient.post(
    `${businessUrl}/${businessPlanId}/ai-reports/generate`
  );
}

export function download(reportId) {
  return axiosClient.get(`${reportUrl}/${reportId}/url/pre-signed`);
}
